<template>
  <div
    class="my-tooltip"
  >
    <div
      v-if="!tooltip"
    >
      <slot />
    </div>

    <template v-else>
      <template v-if="showIcon">
        <div
          class="my-tooltip-default"
        >
          <slot />

          <feather-icon
            v-b-tooltip:[prop]="tooltip"
            icon="TagIcon"
            size="12"
            class="text-success ml-1"
          />
        </div>
      </template>
      <template v-else>
        <div
          v-b-tooltip:[prop]="tooltip"
          class="my-tooltip-default"
        >
          <slot />
        </div>
      </template>
    </template>

  </div>
</template>

<script>
import {
  VBTooltip,
} from 'bootstrap-vue'

export default {
  name: 'MyTooltip',
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    tooltip: {
      type: String,
      default: null,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    // 定义触发方式及其弹出位置
    prop: {
      type: String,
      default: () => '.hover.top',
    },
  },
  data() {
    return {
    }
  },
}

</script>

<style lang='scss' scoped>
.my-tooltip{
    display: inline-block;
}
</style>
